import { enableDevTools } from "@fp/ui/env";

const fieldPayEmailDomain = "@myfieldpay.com";

export function isAuthorizedForDevTools(email: string | undefined, emailVerified: boolean, showDevTools?: boolean): boolean {
	if (enableDevTools) return true;
	if (showDevTools) return true;
	if (!email || !emailVerified) return false;
	return email.toLowerCase().endsWith(fieldPayEmailDomain);
}